<template>
  <div class="pagination-wrapper" v-if="totalPage">
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page.sync="currentPageNum"
      next-text="下一页"
      layout="pager, next, slot, jumper"
      :page-size="pageSize"
      :total="total"
      :lastPage='totalPage'
      >
      <span>
        <el-button
          :disabled="currentPageNum === totalPage"
          class="last-pager"
          @click="toLastPage"
          >尾页</el-button>
      </span>
      <span class="totalPage">共{{totalPage}}页</span>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data () {
    return {
      currentPageNum: this.currentPage,
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 50
    },
    totalPage: {
      type: Number,
      default: 0
    }
  },
  computed: {
  },
  watch: {
    // 监听页码
    '$route.query.pageNo' () {
      this.currentPageNum = parseInt(this.$route.query.pageNo, 10)
    }
  },
  created () {
    this.currentPageNum = parseInt(this.$route.query.pageNo, 10)
  },
  methods: {
    handleCurrentChange (val) {
      this.firstPageBtnDisabled = val === 1 ? 1 : 0
      this.lastPageBtnDisabled = val === this.totalPage ? 1 : 0
      this.currentPageNum = val
      this.$emit('handleCurrentChangeSub', val)
      // this.$store.dispatch('clearLastItemDate')
    },
    toLastPage (val) {
      this.currentPageNum = this.totalPage
      this.handleCurrentChange(this.totalPage)
    }
  }
}
</script>

<style lang="less" scoped>
  /* 页码样式 */
.pagination-wrapper {
  position: absolute;
  width: 100%;
  margin: 0 auto;
  height: 100px;
  bottom: 0;
  .el-pagination{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    font-weight: normal;
  }
  /deep/ .el-pagination__editor.el-input {
    width: 50px;
    margin: 0 6px;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4160a5;
    color: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    color: #1743a5;
    background: #f5f8ff;
    min-width: 30px;
    border: 1px solid #697ca4;
    padding: 0 4.5px;
    border-radius: 3px;
    height: 30px;
  }
  /deep/ .el-pagination.is-background .btn-next {
    width: 62px;
    height: 30px;
    border: 1px solid #697ca4;
    background-color: #f5f8ff; 
    color: #1743a5;
  }
  /deep/ .el-pagination__editor.el-input .el-input__inner {
    width: 50px;
    height: 30px;
    border: 1px solid #ddd;
  }
  .last-pager {
    width: 50px;
    height: 30px;
    border: 1px solid #697ca4;
    color: #1743a5;
    text-align: center;
    background: #f5f8ff;
    cursor: pointer;
  }
  .totalPage, .el-pagination__jump {
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .el-pagination__jump {
    color: #333;
    margin-left: 18px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue